/**
 * Service worker registration.
 *
 * - Only registers in production builds. In dev (`npm start`) the SW would
 *   aggressively cache hot-reload bundles, leading to confusing stale UI.
 * - Skips environments where `serviceWorker` isn't available (older Safari,
 *   private windows in some browsers).
 * - When a new SW is found, we auto-activate it on the next navigation
 *   instead of nagging the user with a banner; combined with `skipWaiting()`
 *   inside the SW, this gives near-instant updates.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;
  // Some hosts (incognito on certain browsers) throw on register — wrap it.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const sw = registration.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // A new version is ready — claim immediately so the next route
              // change picks it up. We don't force-reload to avoid disrupting
              // an in-flight checkout/payment session.
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => { /* registration failure is non-fatal */ });
  });
}
